import { ReactElement } from 'react';

import Button from '@/components/controls/Button.tsx';

type ConfirmationMessageModalProps = {
  isOpen: boolean;
  title: string;
  message: string;
  onCancel: () => void;
  cancelButtonText: string;
  onConfirm: () => void;
  confirmButtonText: string;
};

function CustomConfirmationMessageModal({
  isOpen,
  title,
  message,
  onCancel,
  cancelButtonText,
  onConfirm,
  confirmButtonText,
}: ConfirmationMessageModalProps): ReactElement | null {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-49 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white rounded-lg shadow-lg p-6 w-[calc(100%-2rem)] sm:w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-800 text-xl"
          type="button"
          aria-label="Close"
        >
          <i className="pi pi-times" />
        </button>
        <div className="text-h4 mb-3 font-medium text-gray-700 flex items-center py-2">
          <span>{title}</span>
        </div>
        <p>{message}</p>
        <div className="flex flex-col sm:flex-row sm:justify-center gap-3 sm:gap-4 mt-8">
          <Button
            buttonStyle="justify-center items-center px-5 py-2 text-base font-semibold text-white whitespace-nowrap bg-primary-100 hover:bg-primary-200 rounded-lg w-full sm:w-auto"
            text={confirmButtonText}
            buttonType={{ type: 'button' }}
            hasImage={false}
            onClick={onConfirm}
          />
          <Button
            buttonStyle="justify-center items-center px-5 py-2 text-base font-semibold border border-primary-100 text-primary-100 whitespace-nowrap bg-inherit hover:bg-gray-100 rounded-lg w-full sm:w-auto"
            text={cancelButtonText}
            buttonType={{ type: 'button' }}
            hasImage={false}
            onClick={onCancel}
          />
        </div>
      </div>
    </div>
  );
}

export default CustomConfirmationMessageModal;
